<template>
    <div>
        <ul class="m-small">
            <!-- <li v-if="$auth.check('GP_00001')">
                <router-link :to="{ name: 'portal.dashboard' }">
                    <img :src="menuIcon" alt="">
                    <span>{{ $t(`dashboard.title`) }}</span>
                </router-link>
            </li> -->
            <!-- {{ activeMenuItems }} -->
            <template v-for="(item, index) in activeMenuItems">
                <li v-if="checkPermission(item, 'auth')" :key="index">
                    <router-link :to="{ name: item.route }">
                        <i :class="item.icon" />
                        <span>{{ $t(item.text) }}</span>
                    </router-link>
                </li>
            </template>
        </ul>
    </div>
</template>
<script>
    import { CheckPermission } from '../../mixins/acls';
    import MenuIcon from '@modules/portal/images/icons/menu.svg';

    export default {
        mixins: [ CheckPermission ],
        props: {
            moduleCode: {
                required: true,
                type: String
            },
            items: {
                type: Array,
                default: null
            }
        },
        computed: {
            menuIcon() {
                return MenuIcon;
            },
            menuItems(){
                return this.items === null ? this.$store.getters.getMainMenu(this.moduleCode) : this.items;
            },
            activeMenuItems(){
                return this.menuItems.filter(item => item.active || item.active ==undefined);
            },
        }
    }
</script>
